import React from 'react';
import * as api from 'config/api';
import { useRouting } from 'hooks/useRouting';
import { useScroll } from 'hooks/useScroll';
import { commaFormat } from 'components/features/new-report/utils/formatter';

export const AssetStuffingDebtList = ({
  sortedDebtAssetsList,
  isHiddenAssetD,
  getAccountColor,
  updateHideDebt,
}: {
  sortedDebtAssetsList: api.DebtAssetAccountLists[];
  isHiddenAssetD: boolean | null;
  getAccountColor: (acount: string) => string;
  updateHideDebt: () => void;
}) => {
  const { pushRouting } = useRouting();

  const realDebtAmountList = sortedDebtAssetsList.map(list => {
    return list.RealDebtAmount;
  });
  const debtAllPrice = realDebtAmountList.reduce(
    (previousValue, currentValue) => {
      return previousValue + currentValue;
    }
  );

  useScroll();

  return (
    <div className="p-4">
      <div className="flex flex-row items-center mt-2 mb-4">
        <div className="text-sm font-bold">負債総額</div>
        <div className="ml-auto text-2xl font-bold">
          {isHiddenAssetD ? '---' : commaFormat(debtAllPrice)}
          <span className="ml-1 text-xs">円</span>
        </div>
        <div
          className={`icon-eye_${
            isHiddenAssetD ? 'close' : 'open'
          }_img ml-2 text-bluegray-400 cursor-pointer`}
          onClick={() => updateHideDebt()}></div>
      </div>

      {sortedDebtAssetsList.map((list, key) => {
        const color = getAccountColor(list.Account);
        return (
          <div key={key}>
            <div
              className="border rounded-lg px-4 py-6 mb-2 cursor-pointer"
              onClick={(): void =>
                pushRouting(
                  { path: `/accountdetail/${list.Account}` },
                  true,
                  window.scrollY
                )
              }>
              <div
                className="grid"
                style={{ gridTemplateColumns: 'auto 2fr 1fr auto' }}>
                <div
                  className="flex w-4 h-4 rounded-full mt-1 mr-2"
                  style={{ backgroundColor: color }}></div>
                <div className="flex flex-col items-start">
                  <div className="font-bold">{list.AccountName}</div>
                </div>
                <div className="flex items-center ml-auto">
                  {commaFormat(list.RealDebtAmount)}
                  <span className="text-xs">円</span>
                </div>
                <div className="flex items-center ml-4 w-2">
                  <img
                    src="/static/images/icon/icon-arrow-right.svg"
                    alt=""
                    className="w-full"
                  />
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
